<template>
  <div>
    <div class="section-banner">
      <Slick
        ref="bannerSlick"
        :options="homeSlider"
        v-if="eventBanners.length > 0"
      >
        <div v-for="(data, index) in this.eventBanners" :key="index">
          <!-- {{ JSON.stringify(data)}} -->
          <div
            class="bannerContainer"
            @click="goToEventDetails(data, 'banner')"
          >
            <img :src="base_url + data.eh_banner_image" />
          </div>
        </div>
      </Slick>
    </div>
    <div class="wrapper py-5 mt-4 home-movie-event-view">
      <div class="col-xl-11 mx-auto p-0">
        <div class="section-title d-none d-md-block">Events For You</div>
        <b-tabs
          content-class=""
          class="user-profile-tabs profile-tabs events-tabs"
        >
          <!-- <b-tab title="All" active>
          <div class="row row-flex py-3">
            <div
              class="col-6 col-lg-2 px-2"
              v-for="(data, index) in this.allShowingEvents"
              :key="index"
            >
              <div class="event-card" @click="goToEventDetails(data)">
                <img :src="base_url + data.e_image" class="w-100" />
                <div class="event-card-details">
                  <div>
                    <h6 class="mb-0 text-truncate">{{ data.e_name }}</h6>
                    <div>
                      <span>
                        {{ moment(data.es_date).format("MMM. D, YYYY") }} -
                        {{ moment(data.ee_date).format("MMM. D, YYYY") }}
                      </span>
                    </div>
                  </div>
                  <div>
                    <div>
                    <p class="text-pink font-weight-bold text-right">
                      {{data.seat_price[0].currency}} {{ data.seat_price[0].price }}
                    </p>
                  </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </b-tab> -->
          <b-tab title="Now Showing">
            <div class="row row-flex event-row-left-right row-cols-4">
              <div
                class="col-6 col-sm-4 col-md-3 col-lg-3 px-lg-1 px-2"
                v-for="(data, index) in this.nowShowingEvents"
                :key="index"
              >
                <div class="event-card" @click="goToEventDetails(data)">
                  <img
                    :src="base_url + data.e_image"
                    class="w-100 event-image-ht"
                  />
                  <div class="middle">
                    <div class="text">{{ $t("BOOK_NOW") }}</div>
                  </div>
                  <div class="event-card-details">
                    <div>
                      <h6 class="mb-0 text-truncate text-mobile-head">
                        {{ data.e_name }}
                      </h6>

                      <div v-if="data.es_date == data.ee_date">
                        <span class="text-mobile-small">
                          {{ moment(data.es_date).format("MMM. D, YYYY") }}
                        </span>
                      </div>
                      <div v-else class="text-truncate">
                        <span class="text-mobile-small">
                          {{ moment(data.es_date).format("MMM. D, YYYY") }} -
                          {{ moment(data.ee_date).format("MMM. D, YYYY") }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <div>
                        <p class="text-pink font-weight-bold text-right">
                          {{ data.currency }}
                          {{ data.price }}
                          <span v-if="data.seat_type_count > 1">Onwards</span>
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
          <b-tab title="Coming Soon">
            <div class="row row-flex event-row-left-right row-cols-4">
              <div
                class="col-6 col-sm-4 col-md-3 col-lg-3 px-lg-1 px-2"
                v-for="(data, index) in this.upCommingEvents"
                :key="index"
              >
                <div class="event-card" @click="goToEventDetails(data)">
                  <img
                    :src="base_url + data.e_image"
                    class="w-100 event-image-ht"
                  />
                  <div class="event-card-details">
                    <div>
                      <h6 class="mb-0 text-truncate text-mobile-head">
                        {{ data.e_name }}
                      </h6>
                      <div v-if="data.es_date == data.ee_date">
                        <span class="text-mobile-small">
                          {{ moment(data.es_date).format("MMM. D, YYYY") }}
                        </span>
                      </div>
                      <div v-else>
                        <span class="text-mobile-small">
                          {{ moment(data.es_date).format("MMM. D, YYYY") }} -
                          {{ moment(data.ee_date).format("MMM. D, YYYY") }}
                        </span>
                      </div>
                    </div>
                    <div>
                      <div>
                        <p class="text-pink font-weight-bold text-right">
                          {{ data.currency }}
                          {{ data.price }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </b-tab>
        </b-tabs>
      </div>
    </div>
  </div>
</template>
<script>
import Slick from "vue-slick";
import { makeRequest, makeRequestDirect } from "@/helper/internet.js";
import { EVENT_URL } from "@/helper/constant.js";
import moment from "moment";

export default {
  components: {
    Slick
  },
  data() {
    return {
      moment,
      homeSlider: {
        arrows: true,
        slidesToShow: 1,
        centerMode: true,
        centerPadding: "3.5%",
        slidesToScroll: 1,
        autoplay: true,
        autoplaySpeed: 7000,
        responsive: [
          {
            breakpoint: 992,
            settings: {
              arrows: false,
              dots: true,
              centerMode: false,
              slidesToShow: 1,
              autoplaySpeed: 7000,
              autoplay: true,
              slidesToScroll: 1
            }
          }
        ]
      },
      eventBanners: [],
      nowShowingEvents: [],
      upCommingEvents: [],
      allShowingEvents: [],
      base_url: "",
      url: EVENT_URL
    };
  },
  beforeMount() {
    metaInfo.title =
      "Book Tickets Online for all the Bahrain Events | WanasaTime";
    metaInfo.meta[2].content =
      "Book tickets online for all the upcoming Bahrain events on GCC's online ticket booking platform, WanasaTime";

    metaInfo.meta[3].content =
      "bahrain events, upcoming events in bahrain, events in bahrain today";
  },
  mounted() {
    this.getAllData();
  },
  methods: {
    getAllData: function() {
      this.showLoading();

      makeRequest("/v1/event/getAllEvent", "POST", null, null, this.url)
        .then(response => {
          const { error, res } = response;
          if (!error) {
            this.hideLoading();

            console.log(res);
            this.base_url = res.data.base_url;
            this.eventBanners = res.data.banners;
            this.upCommingEvents = res.data.comming_soon;
            this.nowShowingEvents = res.data.now_showing;
            this.allShowingEvents = [
              ...res.data.comming_soon,
              ...res.data.now_showing
            ];
          } else {
            console.log("Response Error ");
          }
        })
        .catch(error => {
          console.log("Error", error);
        });
    },
    goToEventDetails(data, type) {
      if (type == "banner") {
        if (data.eh_banner_url != "") {
          window.open(data.eh_banner_url, "_blank");
          // window.location = data.eh_banner_url;
        } else {
          this.$router.push({
            name: "eventDetails",
            params: {
              eventID: data.event_id
            }
          });
        }
      } else {
        this.$router.push({
          name: "eventDetails",
          params: {
            eventID: data.event_id
          }
        });
      }
    }
  }
};
</script>
<style>
.section-banner .slick-prev {
  left: 5%;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/events.vue